module.exports = __webpack_public_path__ + "static/media/device-not-available.adb75111.svg";